<template>
  <DropdownMenuRadioItem
    v-if="!context.isMobile"
    :value="value"
    as-child
    :disabled="disabled"
    @select="emit('select')"
  >
    <button type="button" :disabled="disabled" :class="buttonClass">
      <slot v-if="slots.icon" name="icon" />
      <component
        :is="iconMappingMicro[props.icon]"
        v-else-if="props.icon"
        class="size-4 shrink-0 text-menu-muted-foreground transition-colors"
      />

      <span class="min-w-0 grow break-words">{{ props.label }}</span>

      <BoltIcon
        v-if="premium"
        class="size-4 shrink-0 text-menu-muted-foreground transition-colors"
      />

      <div v-if="checked" class="grid size-4 shrink-0 place-items-center">
        <div class="size-2 rounded-full bg-blue-400"></div>
      </div>
      <div v-else-if="!premium" class="size-4 shrink-0"></div>
    </button>
  </DropdownMenuRadioItem>

  <DrawerClose v-else as-child @click="onMobileSelect">
    <button type="button" :disabled="disabled" :class="buttonClass">
      <slot v-if="slots.icon" name="icon" />
      <component
        :is="iconMappingMicro[props.icon]"
        v-else-if="props.icon"
        class="size-4 shrink-0 text-menu-muted-foreground transition-colors"
      />

      <span class="min-w-0 grow break-words">{{ props.label }}</span>

      <BoltIcon
        v-if="premium"
        class="size-4 shrink-0 text-menu-muted-foreground transition-colors"
      />

      <div v-if="checked" class="grid size-4 shrink-0 place-items-center">
        <div class="size-2 rounded-full bg-blue-400"></div>
      </div>
      <div v-else-if="!premium" class="size-4 shrink-0"></div>
    </button>
  </DrawerClose>
</template>

<script setup lang="ts">
import { DropdownMenuRadioItem } from "reka-ui";
import { DrawerClose } from "vaul-vue";
import { computed } from "vue";

import BoltIcon from "@/icons/heroicons/bolt-micro.svg";
import {
  type MappedIconMicro,
  iconMappingMicro,
} from "@/icons/icon-mapping-micro";

import { inject } from "./context";
import { injectRadioGroup } from "./radio-context";

const context = inject();
const radioGroup = injectRadioGroup();

const props = defineProps<{
  label: string;
  value: string;
  icon?: MappedIconMicro;
  premium?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  select: [];
}>();

const slots = defineSlots<{
  icon?(): unknown;
}>();

const checked = computed(() => radioGroup.currentValue() === props.value);

const buttonClass = computed(() => [
  "group/item",
  "relative flex shrink-0 cursor-pointer select-none items-center gap-3 self-stretch rounded-md border-none px-3 outline-none",
  "text-left text-sm text-current",
  !context.isMobile ? "py-1" : "py-2",
  props.premium && !props.disabled && "opacity-50",
  props.disabled && "pointer-events-none cursor-not-allowed opacity-50",
  "active:bg-menu-muted data-[highlighted]:bg-menu-muted",
]);

const onMobileSelect = () => {
  radioGroup.select(props.value);
  emit("select");
};
</script>
